<page-heading title="Dashboard" description="Métricas das empresas" />

<!-- Single Card -->
<div class="card">
  <div class="card-body">
    <form class="row" [formGroup]="formGroup">
      <div class="col-md-6 col-lg-6 trend-datepicker">
        <mat-date-range-input [rangePicker]="picker" formGroupName="dateRange">
          <input
            matStartDate
            placeholder="Data inicial"
            formControlName="dateStart"
          />
          <input
            matEndDate
            placeholder="Data final"
            formControlName="dateEnd"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker" />
        <mat-date-range-picker
          #picker
          (selectionChange)="onPeriodChange($event)"
        >
          <mat-datepicker-actions>
            <mat-select (selectionChange)="onPeriodChange($event)">
              <mat-option value="1">Hoje</mat-option>
              <mat-option value="7">Últimos 7 dias</mat-option>
              <mat-option value="15">Últimos 15 dias</mat-option>
              <mat-option value="30">Últimos 30 dias</mat-option>
              <mat-option value="60">Últimos 60 dias</mat-option>
            </mat-select>
            <button mat-raised-button matDatepickerApply>OK</button>
          </mat-datepicker-actions>
        </mat-date-range-picker>
      </div>

      <div class="col-sm-6 col-md-auto col-lg-auto btn-group trend-button">
        <button
          type="submit"
          class="btn btn-primary dropdown-toggle"
          [matMenuTriggerFor]="companiesMenu"
        >
          {{ labelFilterCompany }} <span class="caret"></span>
        </button>
        <mat-menu #companiesMenu="matMenu">
          <div class="input-select-filter w-full p-2 mb-2">
            <input
              placeholder="Nome da Empresa"
              class="input-select-filter input-field"
              type="text"
              (focus)="onFocusCompanies()"
              [formControl]="filterControlCompanies"
              (click)="$event.stopPropagation()"
            />
          </div>
          @if (allCompanies.length > 0) {
            <div class="flex flex-col">
              @for (company of allCompanies; track $index) {
                <mat-checkbox
                  color="primary"
                  (click)="$event.stopPropagation()"
                  (change)="selectCompanies($event)"
                  [value]="company._id"
                  [checked]="
                    formGroup.get('companies').value.includes(company._id)
                  "
                >
                  {{ company.name }}
                </mat-checkbox>
              }
            </div>
          } @else {
            <p class="px-3 d-flex h6">Nenhum resultado encontrado.</p>
          }
        </mat-menu>
      </div>

      <div class="col-sm-6 col-md-auto col-lg-auto btn-group trend-button">
        <button
          type="submit"
          class="btn btn-primary mdi mdi-filter-variant"
          [matMenuTriggerFor]="typeChannelMenu"
        >
          {{ labelFilterTypeChannel }}
        </button>
        <mat-menu #typeChannelMenu="matMenu">
          <button mat-menu-item (click)="searchByTypeChannel(null)">
            Todos
          </button>
          <button mat-menu-item (click)="searchByTypeChannel(cloudApi)">
            Oficial
          </button>
          <button mat-menu-item (click)="searchByTypeChannel(zApi)">
            Não oficial - TrendBusiness
          </button>
        </mat-menu>
      </div>
    </form>
  </div>
</div>

<!-- Small Cards -->
<div class="grid-cards">
  <card-graphic-small-component
    label="Total de empresas"
    [total]="totalCompanies.toString()"
  />
  <card-graphic-small-component
    label="Total de canais"
    [total]="totalChannels.toString()"
  />
  <card-graphic-small-component
    label="Total de usuários"
    [total]="totalUsers.toString()"
  />
  <card-graphic-small-component label="MRR" [total]="'R$ ' + MRR.toString()" />
  <card-graphic-small-component
    label="Total de churn"
    [total]="totalChurn.toString()"
  />
</div>

<!-- Charts -->
<div class="grid-cards-charts">
  <div class="card">
    <div class="d-flex flex-column card-header">
      <h3>ARR</h3>
      <h5 class="text-muted fw-normal">
        Soma de todas as mensalidades vezes 12
      </h5>
    </div>
    <div class="card-body" #ContainerLineRef>
      <ngx-charts-line-chart
        [view]="viewLine"
        [scheme]="colorScheme"
        [results]="ARRData"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        (window:resize)="resizeChart(ContainerLineRef.offsetWidth)"
      />
    </div>
  </div>

  <div class="card">
    <div class="d-flex flex-column card-header">
      <h3>ARPU</h3>
      <h5 class="text-muted fw-normal">Valor por usuário</h5>
    </div>
    <div class="card-body" #ContainerVerticalRef>
      <ngx-charts-bar-vertical
        [view]="viewVertical"
        [scheme]="colorScheme"
        [results]="ARPUData"
        [xAxis]="true"
        [yAxis]="true"
        [legend]="false"
        [showXAxisLabel]="true"
        [showYAxisLabel]="true"
        (window:resize)="resizeChart(ContainerVerticalRef.offsetWidth)"
      />
    </div>
  </div>

  <div class="card">
    <div class="d-flex flex-column card-header">
      <h3>Ticket Médio</h3>
      <h5 class="text-muted fw-normal">
        Ticket médio dos clientes na plataforma
      </h5>
    </div>
    <div class="card-body" #ContainerPieRef>
      <ngx-charts-pie-chart
        [view]="viewPie"
        [scheme]="colorScheme"
        [results]="mediumTicketData"
        [legend]="true"
        [labels]="true"
        (window:resize)="resizeChart(ContainerPieRef.offsetWidth)"
      />
    </div>
  </div>

  <div class="card">
    <div class="d-flex flex-column card-header">
      <h3>LTV</h3>
      <h5 class="text-muted fw-normal">Valor vitalício do cliente</h5>
    </div>
    <div class="card-body" #ContainerAreaRef>
      <ngx-charts-area-chart
        [view]="viewArea"
        [scheme]="colorScheme"
        [results]="LTVData"
        [xAxis]="true"
        [yAxis]="true"
        [legend]="false"
        [showXAxisLabel]="true"
        [showYAxisLabel]="true"
        [autoScale]="true"
        (window:resize)="resizeChart(ContainerAreaRef.offsetWidth)"
      />
    </div>
  </div>
</div>

<!-- Table -->
<div class="card">
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">Código</th>
          <th class="text-primary-emphasis">Data de Criação</th>
          <th class="text-primary-emphasis">Nome</th>
          <th class="text-primary-emphasis">CNPJ</th>
          <th class="text-primary-emphasis">Email</th>
          <th class="text-primary-emphasis">Telefone</th>
          <th class="text-primary-emphasis">Ativa</th>
        </tr>
      </thead>
      <tbody>
        @for (item of pager?.list; track item.code) {
          <tr role="row">
            <td>
              {{ item.code }}
            </td>
            <td>
              {{ item.createdAt | timezoneDate: 'DD/MM/YYYY': getTimezoneCompanyCurrentUser() }}
            </td>
            <td>
              {{ item.name }}
            </td>
            <td>
              {{ item.tin | cnpjType }}
            </td>
            <td>
              {{ item.email }}
            </td>
            <td>
              {{ item.phone }}
            </td>
            <td>
              <i
                class="mdi mdi-circle {{
                  item?.actived ? 'text-success' : 'text-warning'
                }}"
              ></i>
            </td>
          </tr>
        }
      </tbody>
    </table>
    @if (pager.total > pager.perPage) {
      <paginator [pager]="pager" (onPager)="loadPage($event)" />
    }
  </div>
</div>
